import { when } from '@execonline-inc/maybe-adapter';
import { fromEmpty, fromNullable, just, Maybe, nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import PublishedToaster from '../PublishedCollectionModal/PublishedToaster';
import LearningCollectionsStore from '../Store';
import { LearningCollectionsMetadata, LearningCollectionSummariesResource } from '../Types';
import IndexContext from './IndexContext';
import LearningCollectionListItem from './LearningCollectionListItem';
import LearningCollectionsEmpty from './LearningCollectionsEmpty';
import LearningCollectionsNoResults from './LearningCollectionsNoResults';

interface Props {
  learningCollectionSummariesResource: LearningCollectionSummariesResource;
  store: LearningCollectionsStore;
}

const hasNoResults = (metadata: LearningCollectionsMetadata): boolean =>
  metadata.totalUnfilteredCount > 0 && metadata.resultsCount < 1;

function LearningCollectionsList({ learningCollectionSummariesResource, store }: Props) {
  const [saveState, setSaveState] = useState<Maybe<string>>(nothing());

  useEffect(() => {
    fromNullable(sessionStorage.getItem('learningCollectionState')).map((state) => {
      setSaveState(just(state));
    });
    sessionStorage.removeItem('learningCollectionState');
  }, []);

  return fromEmpty(learningCollectionSummariesResource.payload)
    .map((lcsr) => (
      <>
        <PublishedToaster saveState={saveState} />
        {lcsr.map((learningCollectionSummaryResource, idx) => (
          <IndexContext.Provider
            value={lcsr.length - idx}
            key={`ctxProvider-${learningCollectionSummaryResource.payload.id}`}
          >
            <LearningCollectionListItem
              learningCollectionSummaryResource={learningCollectionSummaryResource}
              store={store}
              totalLength={lcsr.length}
            />
          </IndexContext.Provider>
        ))}
      </>
    ))
    .orElse(() =>
      when(hasNoResults(learningCollectionSummariesResource.metadata), {}).map(() => (
        <LearningCollectionsNoResults store={store} />
      )),
    )
    .getOrElse(() => <LearningCollectionsEmpty />);
}

export default observer(LearningCollectionsList);
